import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

import * as enums from '../../enums/index'
import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//components
import { BaseRequestComponent } from '../../baseclasses/BaseRequest.component';
import { UserInfoComponent } from '../../components/ControlGroups/UserInfo.component';
import { CompletionDetailsComponent } from '../../components/ControlGroups/CompletionDetails.component';
import { GeneralDetailsComponent } from '../../components/ControlGroups/GeneralDetails.component';
import { AddressComponent } from '../../components/ControlGroups/Address.component';
import { ContactDetailsComponent } from '../../components/ControlGroups/ContactDetails.component';
import { PricingComponent } from '../../components/ControlGroups/Pricing.component';
import { SalesAndDeliveryDetailsComponent } from '../../components/ControlGroups/SalesAndDeliveryDetails.component';
import { CustomerRequirementsComponent } from '../../components/ControlGroups/CustomerRequirements.component';
import { CoolerDetailsComponent } from '../../components/ControlGroups/CoolerDetails.component';
import { FountainDetailsComponent } from '../../components/ControlGroups/FountainDetails.component';
import { VendorDetailsComponent } from '../../components/ControlGroups/VendorDetails.component';
import { BillingAddressComponent } from '../../components/ControlGroups/BillingAddress.component';
import { NotesComponent } from '../../components/ControlGroups/Notes.component';
import { RequestHeaderComponent } from '../../components/Controls/RequestHeader.component';
import { ChangePhoneNumberDialogComponent } from '../../components/Employees/ChangePhoneNumberDialog.component';

//constants
import { Constants } from '../../constants/Constants';
import { domain } from 'process';
import { SuppressStatusComponent } from '../ControlGroups/SuppressStatus.component';
import { RequestUtil } from '../../util/index';
import BaseNewOutletRequestComponent from 'src/app/baseclasses/BaseNewOutletRequest.component';
import { ContactGridComponent } from '../Grids/ContactGrid.component';
import { PayerContactSelectorComponent } from '../Controls/PayerContactSelector.component';

@Component({
    selector: 'my-createsoldto-customer-request',
    templateUrl: './CreateSoldToCustomerRequest.component.html'
})
export class CreateSoldToCustomerRequestComponent extends BaseNewOutletRequestComponent{

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;
    requestTypeID: number = enums.RequestTypeEnum.SoldToCustomer;
    eventsSubscribedTo: boolean = false;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(PricingComponent) pricingComponent: PricingComponent;
    @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryComponent: SalesAndDeliveryDetailsComponent;
    @ViewChild(CustomerRequirementsComponent) customerRequirementsComponent: CustomerRequirementsComponent;
    @ViewChild(CoolerDetailsComponent) coolerDetailsComponent: CoolerDetailsComponent;
    @ViewChild(FountainDetailsComponent) fountainDetailsComponent: FountainDetailsComponent;
    @ViewChild(VendorDetailsComponent) vendorDetailsComponent: VendorDetailsComponent;
    @ViewChild(BillingAddressComponent) billingAddressComponent: BillingAddressComponent;
    @ViewChild(SuppressStatusComponent) suppressStatusComponent: SuppressStatusComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;
    @ViewChild(PayerContactSelectorComponent) payerContactSelectorComponent: PayerContactSelectorComponent;

    showCustomerRequirements: boolean;
    showEquipmentInstallSections: boolean;
    showSuppressCustomer: boolean;
    displayPayerContactDialog: boolean;
    constructor() {
        super();
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.userInfoComponent.onSalesOfficeChange.subscribe((x: any) => this.userInfoSalesOfficeChange(x));
       
    }

    ngAfterViewInit() {
        super.subscribeToOverallAccountCopyMethodsInContactDetailsSection();
        super.subscribeToOverallAccountCopyMethodsInBillingAddressSection();

        this.payerContactSelectorComponent.onOK.subscribe(() => {
            this.displayPayerContactDialog = false;
            for (var rec of this.payerContactSelectorComponent.contactGridComponent.records) {
                let contactInfo = new ent.ContactInfo(rec); 
                var existingFound = false;
                for (var otherRec of this.contactDetailsComponent.contactGridComponent.records) {    
                    let otherContactInfo = new ent.ContactInfo(otherRec); 
                    if (otherContactInfo.isMatch(contactInfo)) {
                        existingFound = true;
                    }
                }
                if (!existingFound) {
                    this.contactDetailsComponent.contactGridComponent.records.push(contactInfo);
                }
            }
            
            for (var rec of this.contactDetailsComponent.contactGridComponent.records) {
                let contactInfo = new ent.ContactInfo(rec);
                for (var otherRec of this.payerContactSelectorComponent.contactGridComponent.records) {
                    let otherContactInfo = new ent.ContactInfo(otherRec);
                    if (contactInfo.isMatch(otherContactInfo)) {
                        contactInfo.AppliesToPayer = otherContactInfo.AppliesToPayer;
                        contactInfo.setAppliesToDisplayValue();
                        rec.AppliesToDisplayValue = contactInfo.AppliesToDisplayValue;
                    }
                }
            }
            
        });

        this.payerContactSelectorComponent.onCancel.subscribe(() => {
            this.displayPayerContactDialog = false;
        });

        this.billingAddressComponent.onSelectEditPayerContactClicked.subscribe(() => {
            this.showContactPayerSelectorPopup();
        });
        super.ngAfterViewInit();
        
        //#region all of this is functional, but deprecated

        // this.addressComponent.addressComponentChange.subscribe(() => {
        //     this.setAppliesToPayerHidden(this.contactDetailsComponent.contactGridComponent);
        //     this.setAppliesToPayerHidden(this.billingAddressComponent.contactGridComponent);
        //     this.enableContactGrid();
        // });

        // this.billingAddressComponent.billingAddressComponentChange.subscribe(() => {
        //     this.setAppliesToPayerHidden(this.contactDetailsComponent.contactGridComponent);
        //     this.setAppliesToPayerHidden(this.billingAddressComponent.contactGridComponent);
        //     this.enableContactGrid();
        // });

        // this.billingAddressComponent.contactGridComponent.contactChanged.subscribe((x: ent.ContactInfo) => {
        //     this.addContactToOtherContactGrid(this.contactDetailsComponent.contactGridComponent, x);
        // });
        
        // this.contactDetailsComponent.contactGridComponent.contactChanged.subscribe((x: ent.ContactInfo) => {
        //     this.addContactToOtherContactGrid(this.billingAddressComponent.contactGridComponent, x);
        // });

        // this.billingAddressComponent.contactGridComponent.contactDeleted.subscribe((x: ent.ContactInfo) => {
        //     this.deleteFromOtherContactGrid(this.contactDetailsComponent.contactGridComponent, x);
        // });
        
        // this.contactDetailsComponent.contactGridComponent.contactDeleted.subscribe((x: ent.ContactInfo) => {
        //     this.deleteFromOtherContactGrid(this.billingAddressComponent.contactGridComponent, x);
        // });
        //#endregion
        
       
        
    }

    onHide() {
        this.displayPayerContactDialog = false;
    }

    showAppliesToPayerPopup(){
        this.billingAddressComponent.showEditPayerContactsButton = false;
        var isAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.addressComponent.address);
        var isBillingAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.billingAddressComponent.billingInfo.Address);
        var areAddressesEqual = util.AddressUtil.compareAddresses(this.billingAddressComponent.billingInfo.Address, this.addressComponent.address);
        
        if (this.salesAndDeliveryComponent.primaryGroupOverride == undefined 
                || this.pricingComponent.pricingInfo.CustomerOwnershipID == enums.CustomerOwnershipEnum.Franchisee) {
            if(isAddressPopulated == true && isBillingAddressPopulated == true && areAddressesEqual == false){
                var payerContacts = this.contactDetailsComponent.contactGridComponent.records.filter(x=> x.AppliesToPayer == true);
                if (payerContacts.length == 0) {
                    this.billingAddressComponent.showEditPayerContactsButton = true;
                    this.showContactPayerSelectorPopup();
                }
            }
        }
        
    }

    showContactPayerSelectorPopup() {
        this.payerContactSelectorComponent.contactGridComponent.records = [];
        for (var contactInfo of this.contactDetailsComponent.contactGridComponent.records) {
            this.payerContactSelectorComponent.contactGridComponent.records.push(contactInfo);
        }
        this.payerContactSelectorComponent.initializeContactInfo();
        this.displayPayerContactDialog = true;
    }

    //#region Implemented for AR-1119, but never went to production
    // addContactToOtherContactGrid(dest: ContactGridComponent, other: ent.ContactInfo) {
    //     var matchFound: boolean = false;
    //     for (var rec of dest.records) {
    //         let contactInfo = new ent.ContactInfo(rec);
    //         if (contactInfo.isMatch(other)) {
    //             matchFound = true;
    //         }
    //     }
    //     if (matchFound) {
    //         for (var prop in other) {
    //             this[prop] = other[prop];
    //         }
    //     }
    //     else {
    //         dest.records.push(other);
    //     }
    // }

    // deleteFromOtherContactGrid(dest: ContactGridComponent, other: ent.ContactInfo) {
    //     for (var rec of dest.records) {
    //         let contactInfo = new ent.ContactInfo(rec);
    //         if (contactInfo.isMatch(other)) {
    //             dest.records = _.remove(dest.records, x=>x !== rec);
    //             break;
    //         }
    //     }
    // }

    // setAppliesToPayerHidden(contactGrid: ContactGridComponent){
        
    //     contactGrid.recordEditComponent.hideAppliesToPayerCheckbox(true);
        
    //     var isAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.addressComponent.address);
    //     var isBillingAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.billingAddressComponent.billingInfo.Address);
    //     var areAddressesEqual = util.AddressUtil.compareAddresses(this.billingAddressComponent.billingInfo.Address, this.addressComponent.address);
        
    //     if(isAddressPopulated == true && isBillingAddressPopulated == true && areAddressesEqual == false){
    //         contactGrid.recordEditComponent.hideAppliesToPayerCheckbox(false);
    //         this.contactDetailsComponent.contactGridComponent.recordEditComponent.showAppliesToPayer = true;
    //     }
    // }

    // enableContactGrid(){
    //     var isAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.addressComponent.address);
    //     var isBillingAddressPopulated = util.AddressUtil.isEssentialAddressPopulated(this.billingAddressComponent.billingInfo.Address);
    //     var areAddressesEqual = util.AddressUtil.compareAddresses(this.billingAddressComponent.billingInfo.Address, this.addressComponent.address);
        
    //     if(isAddressPopulated == true && isBillingAddressPopulated == true && aredAddressesEqual == false){
    //         this.billingAddressComponent.showContactGrid(false);
    //         this.billingAddressComponent.showContactLabel = true;
    //     }
    // }
    //#endregion

    getRequestTypeID(){
        return enums.RequestTypeEnum.SoldToCustomer;
    }


    onSaveClick(event: any) {

        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.SoldToCustomer,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            SuppressInfo: this.suppressStatusComponent.suppressInfo,
            ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            PricingInfo: this.pricingComponent.pricingInfo,
            SalesAndDeliveryInfo: this.salesAndDeliveryComponent.salesAndDeliveryInfo,
            BillingInfo: this.billingAddressComponent.billingInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID,
            SalesOfficeID: RequestUtil.GetSalesOfficeID(this.userInfoComponent, this.generalDetailsComponent),
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        util.RequestUtil.LoadSerialNumbers(this.requestToSave, this.generalDetailsComponent);

        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursStartString = this.salesAndDeliveryComponent.getStartTime();
        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursEndString = this.salesAndDeliveryComponent.getEndTime();

        if (this.generalDetailsComponent.generalInfo.IncludeSurveyRequest || this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall) {
            this.requestToSave.CustomerRequirementInfo = this.customerRequirementsComponent.customerRequirementInfo;

            this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.customerRequirementsComponent.dayOfWeekMultiSelectComponent, enums.DayType.CustomerNotAvailable);

            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityStartString = this.customerRequirementsComponent.getStartTime();
            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityEndString = this.customerRequirementsComponent.getEndTime();

            if (this.generalDetailsComponent.generalInfo.IncludeSurveyRequest) {
                this.requestToSave.RequestEquipmentClasses = util.RequestUtil.LoadRequestEquipmentClasses(this.requestToSave, this.customerRequirementsComponent.equipmentClassMultiSelectComponent);
            }
            if (this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall) {
                this.requestToSave.VendorLineItems = this.vendorDetailsComponent.vendorLineItemGrid.lineItems;
                this.requestToSave.FountainLineItems = this.fountainDetailsComponent.fountainLineItemGrid.lineItems;
                this.requestToSave.CoolerLineItems = this.coolerDetailsComponent.coolerLineItemGrid.lineItems;

                this.requestToSave.CoolerInfo = this.coolerDetailsComponent.coolerInfo;
                this.requestToSave.FountainInfo = this.fountainDetailsComponent.fountainInfo;
                this.requestToSave.FountainInfo.Flavors = this.fountainDetailsComponent.getFlavors();
                this.requestToSave.VendorInfo = this.vendorDetailsComponent.vendorInfo;

                this.requestToSave.RequestEquipmentClasses = util.RequestUtil.LoadRequestEquipmentClassesFromRequestInstalls(this.requestToSave);

                this.requestToSave.VendorInfo.EquipmentLocations = this.vendorDetailsComponent.equipmentLocationsComponent.getEquipmentLocations();
            }
        }

        if (this.userInfoComponent.request.PhoneNumber) {
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)) {
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        if (util.AddressUtil.isAddressPopulated(this.billingAddressComponent.billingInfo.Address)) {
            this.requestToSave.Addresses.push(this.billingAddressComponent.billingInfo.Address);
        }

        this.requestToSave.RequestProductSizes = util.RequestUtil.LoadRequestProductSizes(this.requestToSave, this.coolerDetailsComponent.productSizeMultiSelectComponent);

        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.deliveryDaysDayOfWeekMultiSelectComponent, enums.DayType.Delivery);
        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.callDaysDayOfWeekMultiSelectComponent, enums.DayType.Call);

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);
    }

    userInfoSalesOfficeChange(salesOffice: ent.SalesOffice) {

        //this.salesAndDeliveryComponent.setCrossDock(crossDock);
        this.salesAndDeliveryComponent.setSalesOffice(salesOffice, null);
    }
    onYes(event: ent.Response) {
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any) {
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any) {
        //do nothing
    }

    onIncludeSurveyRequestChanged(checked: boolean) {
        this.showCustomerRequirements = checked || this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall;
        this.customerRequirementsComponent.showRequestedSurveyDate = checked;
        this.customerRequirementsComponent.requireRequestedSurveyDate = checked;
        this.showOrHideEquipmentClass();
        this.customerRequirementsComponent.updateValidators();
    }

    onIncludeEquipmentInstallChanged(checked: boolean) {
        this.showCustomerRequirements = checked || this.generalDetailsComponent.generalInfo.IncludeSurveyRequest;
        this.showEquipmentInstallSections = checked;
        this.customerRequirementsComponent.showRequestedInstallDate = checked;
        this.customerRequirementsComponent.requireRequestedInstallDate = checked;
        this.showOrHideEquipmentClass();
        this.customerRequirementsComponent.updateValidators();
    }

    showOrHideEquipmentClass() {
        this.customerRequirementsComponent.showEquipmentClass = this.showCustomerRequirements && !this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall;
    }

    onincludeOwnershipChangeChanged(checked: boolean) {
        this.showSuppressCustomer = checked;
    }

    businessTypeLoadDone(event: any){
        
        this.domainDataService.getBusinessTypes().subscribe(x=> {
            for (var item of x){
                if (item.AppliesToSoldTo === false){
                    _.remove(this.generalDetailsComponent.businessTypeDropdownComponent.selectItems, x=>x.value == item.ID);
                }
            }

            this.generalDetailsComponent.businessTypeChanged.subscribe((x: any) => this.onBusinessTypeChanged(x, true));
            if (this.requestID > 0) {
                this.onBusinessTypeChanged(event, false);
            }
        });




    }

    onBusinessTypeChanged(value: number, setOrderMethodValue: boolean) {
        this.salesAndDeliveryComponent.businessTypeID = value;
        this.vendorDetailsComponent.setBusinessType(value);
        this.pricingComponent.setBusinessType(value);
        if (value == enums.BusinessTypeEnum.SecondaryVolume) {
            this.salesAndDeliveryComponent.clearValidators();
            if (setOrderMethodValue) {
                this.salesAndDeliveryComponent.orderMethodDropdown.value = enums.OrderMethodEnum.None;
            }

            this.salesAndDeliveryComponent.orderMethodDropdown.disabled = true;
        }
        else {
            this.salesAndDeliveryComponent.orderMethodDropdown.disabled = false;
            if (setOrderMethodValue) {
                this.salesAndDeliveryComponent.orderMethodDropdown.value = enums.OrderMethodEnum.ECOM;
            }
            this.salesAndDeliveryComponent.setValidators();

        }
    }

    customerOwnershipChanged(event: number) {
        
        this.billingAddressComponent.handleCustomerOwnershipChange(event);
        this.showAppliesToPayerPopup();
    }

    primaryGroupOverrideChanged(event: ent.PrimaryGroupOverride) {
        this.salesAndDeliveryComponent.setPrimaryGroupOverride(event);

        this.eventsSubscribedTo = true;
        this.addressComponent.addressComponentChange.subscribe(() => {
            this.showAppliesToPayerPopup();
        });

        this.billingAddressComponent.billingAddressComponentChange.subscribe(() => {
            this.showAppliesToPayerPopup();
        });
        
    }

    getDistributionChannel(): string {
        return Constants._DISTRIBUTION_CHANNEL_DSD;
    }

}